export const getters = {
  isMobile: state => state.device === 'mobile',
  isIOS: state => ['iphone', 'ipad', 'ipod'].findIndex(el => state.agent.toLowerCase().indexOf(el) > -1) > -1
}